module.exports = __webpack_public_path__ + "static/img/business5.69d5742.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business5.jpg
// module id = 5ca0
// module chunks = 9